import { createTheme } from '@mui/material/styles';

// A custom theme for this app
const theme = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#3d98ff',
      light: '#3d98ff',
      dark: '#3d98ff',
    },
  },
  components: {
    // Name of the component
    MuiTextField: {
      styleOverrides: {
        // Name of the slot
        root: {
          // padding: '20px 10px',
          margin: '10px',
          backgroundColor: '#fff',
          width: '100%',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          width: '100%',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          margin: '5px',
        },
      },
    },
  },
});
export default theme;
